module.exports = __webpack_public_path__ + "img/TXT.1b680345.png";